import { Col, Row, Form } from "antd";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import DateRangePicker from "../../../../components/atoms/DateRangePicker";
import Explain from "../../../../components/atoms/Explain";
import Table from "../../../../components/atoms/Table";
import TimePicker from "../../../../components/atoms/TimePicker";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import { RepairShopTemporaryChangedBusiness } from "../../../../model/RepairShopTemporaryChangedBusiness";
import sharedConstants from "../../../../shared/constants";
import { DayOffDay } from "../../../../shared/enums";
import { theme } from "../../../../theme";
import { ValidationStatus } from "../../../Register/components/types";
import { getTemporaryBusinessChangeTimeColumns } from "../../constants";
import { RenderInputProps, TimeMode } from "../../Interface";
import {
  StyledDateRangePicker,
  StyledInputTitle,
  StyledTemporaryRestWrapper,
  Wave,
} from "../../styles";
import {
  checkDuplicatedBreakTime,
  makeDisabledTime,
  stringTimeToMoment,
} from "../../utils";
import InputWrapper from "../InputWrapper";
import MinusGhostButton from "../MinusGhostButton";
import PlusTimeTextButton from "../PlusTimeTextButton";

const { Item } = Form;
const TemporaryChangeInputs: React.FC<RenderInputProps> = ({ form }) => {
  const temporaryChangeArray: RepairShopTemporaryChangedBusiness[] =
    Form.useWatch("temporaryChangeArray", form);
  const temporaryCloseRanges = Form.useWatch("temporaryCloseRanges", form);
  const isNotTemporaryChangeArrayUndefined =
    temporaryChangeArray &&
    temporaryChangeArray[0]?.temporaryBusinessStartedAt !== undefined;
  const renderRestTimes = () => {
    const breakTimes =
      (temporaryChangeArray && temporaryChangeArray[0].repairShopBreakTimes) ||
      [];
    const { startBusinessTime, endBusinessTime } = (temporaryChangeArray &&
      temporaryChangeArray[0]) || {
      startBusinessTime: undefined,
      endBusinessTime: undefined,
    };
    const fatestStartTime = stringTimeToMoment(startBusinessTime);
    const latestEndTime = stringTimeToMoment(endBusinessTime);
    return [
      ...breakTimes.map((val, index) => {
        const { startBreakTime, endBreakTime } = val;
        const checkDuplication = checkDuplicatedBreakTime({
          target: {
            startTime: stringTimeToMoment(startBreakTime),
            endTime: stringTimeToMoment(endBreakTime),
          },
          times: [
            ...breakTimes
              .filter((val, arrayIdx) => index !== arrayIdx)
              .map((val) => ({
                startTime: stringTimeToMoment(val.startBreakTime),
                endTime: stringTimeToMoment(val.endBreakTime),
              })),
            { startTime: fatestStartTime, endTime: latestEndTime },
          ],
        });
        const getStatus = (): ValidationStatus => {
          if (
            (val.startBreakTime && !val.endBreakTime) ||
            (val.endBreakTime && !val.startBreakTime)
          ) {
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };
          }
          if (checkDuplication.status === "error") return checkDuplication;

          return { status: undefined, explain: undefined };
        };
        return (
          <Col span={24} key={index}>
            <ExplainWrapper status={getStatus()}>
              <Row key={index} gutter={[12, 0]}>
                <Col style={{ padding: "0px" }} flex="0 0 200px">
                  <Item
                    noStyle
                    rules={[
                      {
                        validator: async () => {
                          const validation = getStatus();
                          if (validation.status === "error")
                            return Promise.reject(
                              new Error(validation.explain)
                            );

                          return Promise.resolve;
                        },
                      },
                    ]}
                    name={`temporaryChangeBreakTime_${index}`}
                  />
                  <TimePicker
                    disabled={!isNotTemporaryChangeArrayUndefined}
                    value={stringTimeToMoment(val.startBreakTime)}
                    onOk={(selectedValue) => {
                      const newTemporaryChangeArray = [...temporaryChangeArray];
                      const newBreakTimes = [...breakTimes];
                      newBreakTimes[index].startBreakTime = selectedValue
                        ? selectedValue.format("HH:mm")
                        : undefined;
                      form.setFieldsValue({
                        temporaryChangeArray: newTemporaryChangeArray.map(
                          (val) => ({
                            ...val,
                            repairShopBreakTimes: newBreakTimes,
                          })
                        ),
                      });
                    }}
                    status={getStatus().status ? "error" : undefined}
                    disabledTime={() =>
                      makeDisabledTime({
                        fatestStartTime,
                        latestEndTime,
                        fatestEndTime: stringTimeToMoment(val.endBreakTime),
                        latestStartTime: stringTimeToMoment(val.startBreakTime),
                        disabledTimes: breakTimes.map((val) => ({
                          startTime: stringTimeToMoment(val.startBreakTime),
                          endTime: stringTimeToMoment(val.endBreakTime),
                        })),
                      })
                    }
                    endHour={stringTimeToMoment(val.endBreakTime)?.hours()}
                    type={TimeMode.START}
                  />
                </Col>
                <Col>
                  <Wave />
                </Col>
                <Col style={{ padding: "0px" }} flex="0 0 200px">
                  <TimePicker
                    disabled={!isNotTemporaryChangeArrayUndefined}
                    value={stringTimeToMoment(val.endBreakTime)}
                    onOk={(selectedValue) => {
                      const newTemporaryChangeArray = [...temporaryChangeArray];
                      const newBreakTimes = [...breakTimes];
                      newBreakTimes[index].endBreakTime = selectedValue
                        ? selectedValue.format("HH:mm")
                        : undefined;

                      form.setFieldsValue({
                        temporaryChangeArray: newTemporaryChangeArray.map(
                          (val) => ({
                            ...val,
                            repairShopBreakTimes: newBreakTimes,
                          })
                        ),
                      });
                    }}
                    status={getStatus().status ? "error" : undefined}
                    disabledTime={() =>
                      makeDisabledTime({
                        fatestStartTime,
                        latestEndTime,
                        fatestEndTime: stringTimeToMoment(val.endBreakTime),
                        latestStartTime: stringTimeToMoment(val.startBreakTime),
                        disabledTimes: breakTimes.map((val) => ({
                          startTime: stringTimeToMoment(val.startBreakTime),
                          endTime: stringTimeToMoment(val.endBreakTime),
                        })),
                        mode: TimeMode.END,
                      })
                    }
                    startHour={stringTimeToMoment(val.startBreakTime)?.hours()}
                    type={TimeMode.END}
                  />
                </Col>
                <Col>
                  <MinusGhostButton
                    onClick={() => {
                      const newTemporaryChangeArray = [...temporaryChangeArray];
                      const newBreakTimes = breakTimes.filter(
                        (val, idx) => idx !== index
                      );
                      const newTempChanges = newTemporaryChangeArray.map(
                        (val) => ({
                          ...val,
                          repairShopBreakTimes: newBreakTimes,
                        })
                      );
                      form.setFieldsValue({
                        temporaryChangeArray: newTempChanges,
                      });
                    }}
                  />
                </Col>
              </Row>
            </ExplainWrapper>
          </Col>
        );
      }),
    ];
  };
  return (
    <>
      <StyledTableWrapper>
        <InputWrapper title="일시적 운영시간 변경" isOptional hasLine={false}>
          <Explain
            color={theme.colors.gray3}
            explain="일시적으로 운영시간 변경이 필요한 경우에만 사용하세요."
          />
          <Item noStyle name="repairShopTemporaryBusinesses" />
          <Item noStyle name="temporaryChangeArray" />
          <Table
            size="large"
            columns={getTemporaryBusinessChangeTimeColumns(
              form,
              temporaryCloseRanges || []
            )}
            dataSource={temporaryChangeArray}
            pagination={false}
            rowKey=""
          />
        </InputWrapper>
      </StyledTableWrapper>
      <InputWrapper title="" isOptional hasLine={false}>
        <StyledTemporaryRestWrapper>
          <Row gutter={[0, 12]}>
            <Col span={24}>
              <StyledInputTitle>특정일 휴게시간</StyledInputTitle>
            </Col>
            <Col span={24}>
              <Explain
                color={theme.colors.gray3}
                explain="일시적으로 운영시간을 변경한 기간동안 그에 따른 휴게시간 변경이 필요한 경우만 사용하세요."
              />
            </Col>
            <Col span={24}>
              <Row gutter={[0, 4]}>
                <Col span={24}>
                  <StyledDateRangePicker>
                    <DateRangePicker
                      disabled
                      value={
                        isNotTemporaryChangeArrayUndefined
                          ? [
                              moment(
                                temporaryChangeArray[0]
                                  ?.temporaryBusinessStartedAt
                              ),
                              moment(
                                temporaryChangeArray[0]
                                  ?.temporaryBusinessEndedAt
                              ),
                            ]
                          : undefined
                      }
                    />
                  </StyledDateRangePicker>
                </Col>
                <Col span={24}>
                  <StyledSmallText>
                    ‘일시적 운영시간 변경’ 항목에서 추가한 날짜입니다.
                  </StyledSmallText>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[12, 0]}>
                <Col span={24}>{renderRestTimes()}</Col>
                <Col span={24}>
                  <Item noStyle name="temporaryRepairShopBreakTime" />
                  {isNotTemporaryChangeArrayUndefined ? (
                    <PlusTimeTextButton
                      arrayLength={temporaryChangeArray?.reduce((pre, next) => {
                        if (next.repairShopBreakTimes)
                          return pre + next.repairShopBreakTimes.length;
                        return pre;
                      }, 0)}
                      onClick={() => {
                        const newTemporaryChangeArray = [
                          ...temporaryChangeArray,
                        ];

                        const newTempChanges = newTemporaryChangeArray.map(
                          (val) => ({
                            ...val,
                            repairShopBreakTimes: [
                              ...(val.repairShopBreakTimes || []),
                              {
                                breakDayTypes: DayOffDay.SUNDAY,
                                startBreakTime: undefined,
                                endBreakTime: undefined,
                              },
                            ],
                          })
                        );
                        form.setFieldsValue({
                          temporaryChangeArray: newTempChanges,
                          temporaryRepairShopBreakTime: {
                            breakDayTypes: DayOffDay.SUNDAY,
                            startBreakTime: undefined,
                            endBreakTime: undefined,
                          },
                        });
                      }}
                    />
                  ) : null}
                </Col>
              </Row>
            </Col>
          </Row>
        </StyledTemporaryRestWrapper>
      </InputWrapper>
    </>
  );
};
const StyledTableWrapper = styled.div`
  margin-bottom: 12px;
  color: ${theme.colors.gray6};
`;
const StyledSmallText = styled.div`
  margin-top: 4px;
  ${theme.typo.body.r12};
  color: ${theme.colors.gray3};
`;
export default TemporaryChangeInputs;
